<template>
    <div class="fill-height">

        <div v-if="loadingPartnerInfo" class="d-flex align-center justify-center fill-height">
            <app-centre-loader label="Loading Partner Info"></app-centre-loader>
        </div>
        <template v-else-if="partnerInfo">

            <div class="d-flex flex-wrap justify-space-around align-baseline">
                <v-card style="max-width: 600px" class="ma-2 flex-grow-1 flex-equal">
                    <v-card-title class="dlg-title-bar">
                        {{partnerInfo.name}}
                    </v-card-title>

                    <v-card-text class="pt-3">
                        <div class="d-flex align-center">
                            <v-text-field
                                    class="flex-grow-1"
                                    :readonly="true"
                                    outlined
                                    label="Partner Code"
                                    :value="partnerInfo.code"
                                    dense
                                    hide-details
                                    prepend-icon="mdi-pound"
                            ></v-text-field>
                            <div class="px-2">
                                <v-tooltip top>
                                    <template v-slot:activator="{on}">
                                        <v-btn
                                                @click="copy(partnerInfo.code)"
                                                small
                                                icon
                                                color="primary"
                                                v-on="on"
                                                ref="partnerCode"
                                        >
                                            <v-icon>mdi-content-copy</v-icon>
                                        </v-btn>
                                    </template>
                                    Copy
                                </v-tooltip>
                            </div>
                        </div>

                        <div class="d-flex align-center pt-4">
                            <v-text-field
                                    class="flex-grow-1"
                                    :readonly="true"
                                    outlined
                                    label="Signup Link"
                                    :value="signupLink"
                                    dense
                                    hide-details
                                    prepend-icon="mdi-link-variant"
                            ></v-text-field>
                            <div class="px-2">
                                <v-tooltip top>
                                    <template v-slot:activator="{on}">
                                        <v-btn
                                                @click="copy(signupLink)"
                                                small
                                                icon
                                                color="primary"
                                                v-on="on"
                                                ref="signupLink"
                                        >
                                            <v-icon>mdi-content-copy</v-icon>
                                        </v-btn>
                                    </template>
                                    Copy
                                </v-tooltip>
                            </div>
                        </div>

                        <v-form ref="editInfoForm" @submit="$event.preventDefault()">
                            <v-text-field
                                    class="flex-grow-1 mt-4"
                                    outlined
                                    label="Partner Name"
                                    v-model="editInfo.name"
                                    dense
                                    hide-details="auto"
                                    prepend-icon="mdi-account-tie"
                                    :rules="[validationRules.required]"
                            ></v-text-field>

                            <v-text-field
                                    class="flex-grow-1 mt-4"
                                    outlined
                                    label="Email Address"
                                    v-model="editInfo.email"
                                    dense
                                    hide-details="auto"
                                    prepend-icon="mdi-email"
                                    :rules="[validationRules.required, validationRules.email]"
                            ></v-text-field>

                            <v-text-field
                                    class="flex-grow-1 mt-4"
                                    outlined
                                    label="Contact No."
                                    v-model="editInfo.contactNumber"
                                    dense
                                    hide-details="auto"
                                    prepend-icon="mdi-phone"
                                    :rules="[validationRules.required, validationRules.cellNo]"
                            ></v-text-field>
                            <!--Bank Account-->
                            <v-combobox
                                    v-model="editInfo.account.bank"
                                    class="mt-4"
                                    outlined
                                    prepend-icon="mdi-bank"
                                    label="Bank"
                                    hide-details="auto"
                                    color="primary"
                                    dense
                                    :rules="[validationRules.required]"
                                    :items="banks"
                                    @input="setBranchCode"
                            >

                            </v-combobox>

                            <v-text-field
                                    v-model="editInfo.account.branchCode"
                                    class="mt-4"
                                    outlined
                                    prepend-icon=""
                                    label="Branch Code"
                                    hide-details="auto"
                                    color="primary"
                                    dense
                                    :rules="[validationRules.required]"
                            >
                                <template v-slot:prepend>
                                    <div class="px-3"></div>
                                </template>
                            </v-text-field>

                            <v-text-field
                                    v-model="editInfo.account.accountNo"
                                    class="mt-4"
                                    outlined
                                    prepend-icon=""
                                    label="Account No."
                                    hide-details="auto"
                                    color="primary"
                                    dense
                                    :rules="[validationRules.required]"
                            >
                                <template v-slot:prepend>
                                    <div class="px-3"></div>
                                </template>
                            </v-text-field>

                            <v-autocomplete
                                    v-model="editInfo.account.type"
                                    class="mt-4"
                                    outlined
                                    label="Account Type"
                                    hide-details="auto"
                                    color="primary"
                                    dense
                                    :rules="[validationRules.required]"
                                    :items="['Cheque', 'Savings']"
                            >
                                <template v-slot:prepend>
                                    <div class="px-3"></div>
                                </template>
                            </v-autocomplete>

                            <v-text-field
                                    v-model="editInfo.account.vatNo"
                                    class="mt-4"
                                    outlined
                                    prepend-icon="mdi-currency-usd"
                                    label="Vat No"
                                    hide-details="auto"
                                    color="primary"
                                    dense
                            >
                            </v-text-field>
                            <!--Address-->
                            <v-text-field
                                    v-model="editInfo.address.line1"
                                    class="mt-4"
                                    outlined
                                    prepend-icon="mdi-map-marker"
                                    label="Address Line 1"
                                    hide-details="auto"
                                    color="primary"
                                    dense
                                    :rules="[validationRules.required]"
                            />
                            <v-text-field
                                    v-model="editInfo.address.line2"
                                    class="mt-4"
                                    outlined
                                    prepend-icon="mdi-map-marker"
                                    label="Address Line 2"
                                    hide-details="auto"
                                    color="primary"
                                    dense
                            >
                                <template v-slot:prepend>
                                    <div class="px-3"></div>
                                </template>
                            </v-text-field>
                            <v-combobox
                                    v-model="city"
                                    class="mt-4"
                                    outlined
                                    prepend-icon="mdi-map-marker"
                                    label="City / Town"
                                    hide-details="auto"
                                    color="primary"
                                    dense
                                    :rules="[validationRules.required]"
                                    :items="towns"
                            >
                                <template v-slot:prepend>
                                    <div class="px-3"></div>
                                </template>
                            </v-combobox>
                            <v-combobox
                                    v-model="editInfo.address.region"
                                    class="mt-4"
                                    outlined
                                    prepend-icon="mdi-map-marker"
                                    label="Region"
                                    hide-details="auto"
                                    color="primary"
                                    dense
                                    :rules="[validationRules.required]"
                                    :items="provinces"
                            >
                                <template v-slot:prepend>
                                    <div class="px-3"></div>
                                </template>
                            </v-combobox>
                            <v-text-field
                                    v-model="editInfo.address.areaCode"
                                    class="mt-4"
                                    outlined
                                    prepend-icon=""
                                    label="Area Code"
                                    hide-details="auto"
                                    color="primary"
                                    dense
                                    :rules="[validationRules.required]"
                            >
                                <template v-slot:prepend>
                                    <div class="px-3"></div>
                                </template>
                            </v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end">
                        <v-btn
                                ref="passwordBtn"
                                color="primary"
                                small
                                outlined
                                class="mr-2"
                                @click="editInfo = JSON.parse(JSON.stringify(partnerInfo))"
                                :disabled="savingPartnerInfo"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                                ref="passwordBtn"
                                color="primary"
                                small
                                :loading="savingPartnerInfo"
                                :disabled="savingPartnerInfo"
                                @click="savePartnerInfo"
                        >
                            Save Changes
                        </v-btn>
                    </v-card-actions>
                </v-card>

                <v-card style="max-width: 600px" class="ma-2 flex-grow-1 flex-equal">
                    <v-card-title class="dlg-title-bar">
                        Users
                    </v-card-title>
                    <v-data-table
                            :headers="userColumns"
                            :items="partnerUsers"
                            :search="$store.state.ref.dashboard.filterStr"
                            :items-per-page="partnerUsers.length"
                            hide-default-footer
                            fixed-header
                            sortBy="name"
                            dense
                            item-key="_id"
                    >
                        <template v-slot:item.name="{ item }">
                            <div class="d-flex align-center overline" style="white-space: nowrap">
                                <v-icon left small>mdi-account</v-icon>
                                {{ item.name }}
                            </div>
                        </template>

                        <template v-slot:item.remove="{ item }">
                            <v-tooltip top :disabled="removingUser">
                                <template v-slot:activator="{on}">
                                    <div style="display: inline-block" v-on="on">
                                        <v-btn
                                                :disabled="removingUser || item._id === user._id || partnerUsers.length <= 1"
                                                color="error"
                                                small
                                                icon
                                                @click="removeUser(item)"
                                        >
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                                <template v-if="partnerUsers.length <= 1">
                                    Can't remove only site
                                </template>
                                <template v-else-if="item._id === user._id">
                                    Can't remove yourself from partner account
                                </template>
                                <template v-else>
                                    Remove User
                                </template>
                            </v-tooltip>
                        </template>
                    </v-data-table>

                    <v-card-actions class="d-flex justify-end">
                        <v-btn
                                ref="passwordBtn"
                                color="primary"
                                small
                                @click="showAddUser = true"
                        >
                            Add User
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </div>


            <app-dlg
                    v-if="showAddUser"
                    :show-dlg.sync="showAddUser"
                    title="Add user to partner code"
                    :dlg-width="500"
            >

                <template>
                    <v-form ref="addUserForm" @submit="$event.preventDefault()">
                        <v-text-field
                                v-model="addUserUsername"
                                outlined
                                prepend-icon="mdi-account"
                                label="Username"
                                hide-details="auto"
                                color="primary"
                                dense
                                :rules="[validationRules.required, validationRules.email]"
                                :error-messages="addUserUsernameErrors"
                                ref="addUserUsername"
                                @keydown.enter="addUser"
                                @input="addUserUsernameErrors = null"
                        >
                        </v-text-field>
                    </v-form>
                </template>

                <template v-slot:actions>
                    <v-btn
                            class="ml-2"
                            small
                            color="primary"
                            @click="showAddUser = false"
                            outlined
                            size="small"
                            :disabled="addingUser"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                            @click="addUser"
                            small
                            class="ml-2"
                            color="primary"
                            :loading="addingUser"
                            :disabled="addingUser"
                    >
                        Add User
                    </v-btn>

                </template>
            </app-dlg>


        </template>
    </div>
</template>

<script>

import AppDlg from "@/components/Shared/AppDlg";
const partnerTemplate = {
    code: null,
    name: null,
    email: null,
    contactNumber: null,
    account: {
        branchCode: null,
        accountNo: null,
        bank: null,
        type: null,
    },
    address: {
        line1: null,
        line2: null,
        region: null,
        city: null,
        areaCode: null,
    },
    vatNo: null
}

const places = [
    {province: "Eastern Cape", places: [ "Alice", "Aliwal North", "Bhisho", "Burgersdorp", "Butterworth", "Cradock", "Dimbaza", "East London", "Elliot", "Fort Beaufort", "Gonubie", "Graaff-Reinet", "Grahamstown", "Humansdorp", "Jeffreys Bay", "King William's Town", "Mdantsane", "Middelburg", "Umtata", "Ndevana", "Port Alfred", "Port Elizabeth", "Queenstown", "Somerset East", "Stutterheim", "Uitenhage", "Whittlesea", ]},
    {province: "Free State", places: [ "Allanridge", "Bethlehem", "Bloemfontein", "Bothaville", "Botshabelo", "Bultfontein", "Clocolan", "Deneysville", "Ficksburg", "Frankfort", "Harrismith", "Heilbron", "Hoopstad", "Kroonstad", "Ladybrand", "Marquard", "Odendaalsrus", "Parys", "Phomolong", "Phuthaditjhaba", "Reitz", "Sasolburg", "Senekal", "Thaba Nchu", "Theunissen", "Tshiame", "Viljoenskroon", "Villiers", "Virginia", "Vrede", "Welkom", "Wesselsbron", "Zastron", ]},
    {province: "Gauteng", places: [ "Bronkhorstspruit", "Carletonville", "Cullinan", "Ekangala", "Evaton", "Fochville", "Hammanskraal", "Heidelberg", "Johannesburg", "Nigel", "Pretoria", "Soshanguve", "Vereeniging", "Westonaria", ]},
    {province: "KwaZulu-Natal", places: [ "Ballito", "Clydesdale", "Dundee", "Durban", "Empangeni", "Estcourt", "Folweni", "Frischgewaagd", "Glencoe", "Greytown", "Howick", "Kokstad", "Ladysmith", "Mandini", "Margate", "Mondlo", "Mooi Rivier", "Mpophomeni", "Mpumalanga", "Mtubatuba", "Ncotshane", "Newcastle", "Pietermaritzburg", "Port Shepstone", "Richards Bay", "Shakaskraal", "Stanger", "Tongaat", "Ulundi", "Umzinto", "Vryheid", "Wembesi", ]},
    {province: "Limpopo", places: [ "Amandelbult Mine", "Warmbad", "Lebowakgomo", "Ellisras", "Louis Trichardt", "Mankweng", "Marapong", "Modimolle", "Potgietersrus", "Naboomspruit", "Musina", "Nkowankowa", "Phalaborwa", "Polokwane", "Praktiseer", "Thabazimbi", "Thohoyandou", "Tshitereke", "Vaalwater", "Tzaneen"]},
    {province: "Mpumalanga", places: [ "Balfour", "Barberton", "eMakhazeni", "Bethal", "Carolina", "Vlakpoort", "Delmas", "Dwarsloop", "Elukwatuni", "Embalenhle", "Piet Retief", "Ermelo", "Hendrina", "Kamaqhekeza", "Kinross", "Ga-Nala", "Kwaggafontein", "Leslie", "Lydenburg", "Middelburg", "Mkhuhlu", "Moloto", "Mbombela", "Phola", "Redhill", "Sabie", "Siyabuswa", "Standerton", "Tekwane", "Trichardt", "Tweefontein", "Vaalbank", "Verena", "Volksrust", "White River", "Witbank", ]},
    {province: "Northern Cape", places: [ "Barkly West", "Colesberg", "De Aar", "Douglas", "Jan Kempdorp", "Kimberley", "Postmasburg", "Ritchie", "Upington", "Warrenton", ]},
    {province: "North West", places: [ "Bloemhof", "Brits", "Christiana", "Coligny", "Hartbeestfontein", "Hartbeestfontein A", "Hartebeespoort", "Itsoseng", "Klerksdorp", "Koster", "Letlhabile", "Lichtenburg", "Mafikeng", "Rooikoppies", "Orkney", "Ottosdal", "Potchefstroom", "Rustenburg", "Schweizer-Reneke", "Stilfontein", "Ventersdorp", "Vryburg", "Wolmaransstad", "Zeerust", ]},
    {province: "Western Cape", places: [ "Atlantis", "Beaufort West", "Bredasdorp", "Cape Town", "Ceres", "George", "Grabouw", "Groot Brakrivier", "Hermanus", "Knysna", "Malmesbury", "Montagu", "Mossel Bay", "Oudtshoorn", "Paarl", "Plettenberg Bay", "Riversdale", "Robertson", "Saldanha", "Somerset West", "Stellenbosch", "Swellendam", "Vredenburg", "Vredendal", "Worcester", ]},
]

const banks = [
    {name: "ABSA Bank" , branchCode: "632 005"},
    {name: "Bank of Athens" , branchCode: "410 506"},
    {name: "Bidvest Bank" , branchCode: "462 005"},
    {name: "Capitec Bank" , branchCode: "470 010"},
    {name: "FNB" , branchCode: "250 655"},
    {name: "Investec" , branchCode: "580 105"},
    {name: "Nedbank" , branchCode: "198 765"},
    {name: "SA Post Bank (Post Office)" , branchCode: "460 005"},
    {name: "Standard Bank" , branchCode: "051 001"},
]

import AppPartner from "@/components/Partner/AppPartner";
import AppCentreLoader from "@/components/Shared/AppCentreLoader";
import {copyText, mergeRecursive, nameSort, validationRules} from "@/core/codeFunctions";
import {mapGetters} from "vuex";


export default {
    components: {AppDlg, AppCentreLoader, AppPartner},
    props: {
        val: Boolean,
    },
    data() {
        return {
            partnerInfo: null,
            editInfo: null,
            partnerUsers: null,
            loadingPartnerInfo: true,
            validationRules,
            savingPartnerInfo: false,
            userColumns: [
                {text: 'Name', value: 'name'},
                {text: 'Username', value: 'username'},
                {text: 'Remove User', value: 'remove', sortable: false, align: 'center'}
            ],
            showAddUser: false,
            addingUser: false,
            addUserUsername: null,
            addUserUsernameErrors: null,
            removingUser: false,

        }
    },
    mounted() {
        this.loadPartnerInfo();
    },
    watch: {
        showAddUser(val) {
            this.addUserUsername = null;
            this.addUserUsernameErrors = null;
            if (val)
                setTimeout(() => {
                    this.$refs.addUserUsername.focus()
                }, 500)
        }
    },
    methods: {

        async removeUser(removeUser) {
            console.log({removeUser})

            this.removingUser = true
            try {
                const res = await this.$newReq('DELETE', `partner/admin/removeUser`, {_id: removeUser._id})
                this.partnerUsers = res.users
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                this.removingUser = false
            }
        },

        async addUser() {

            if (!this.$refs.addUserUsername.validate())
                return false

            this.addingUser = true
            try {
                const res = await this.$newReq('POST', `partner/admin/addUser`, {username: this.addUserUsername.toLowerCase()})

                if (!res.status)
                    return this.addUserUsernameErrors = ['User not found']

                this.partnerUsers = res.users
                this.showAddUser = false

            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                this.addingUser = false
            }

        },
        async savePartnerInfo() {
            if (!this.$refs.editInfoForm.validate())
                return this.$snack.error('Complete all required fields')

            this.savingPartnerInfo = true
            try {
                const partner = await this.$newReq('POST', `partner/admin`, this.editInfo)
                this.partnerInfo = mergeRecursive(JSON.parse(JSON.stringify(partnerTemplate)), partner);
                this.editInfo = mergeRecursive(JSON.parse(JSON.stringify(partnerTemplate)), partner);
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                this.savingPartnerInfo = false
            }
        },
        setBranchCode(bank) {
            const bankObj = banks.find(obj => obj.name === bank)
            console.log(bankObj, bank)
            this.editInfo.account.branchCode = bankObj ? bankObj.branchCode || null : null
        },
        copy(val) {
            copyText(document, val)
            this.$snack.info('Copied to clipboard')
        },
        async loadPartnerInfo() {
            try {
                this.loadingPartnerInfo = true;
                const {partner, users} = await this.$newReq('GET', `partner/admin/startup`)
                this.partnerInfo = mergeRecursive(JSON.parse(JSON.stringify(partnerTemplate)), partner);
                this.editInfo = mergeRecursive(JSON.parse(JSON.stringify(partnerTemplate)), partner);
                this.partnerUsers = users;
            } catch (e) {
                this.$snack.netWorkError()
                console.log(e)
            } finally {
                this.loadingPartnerInfo = false
            }

        }
    },
    computed: {
        ...mapGetters(["user"]),
        signupLink() {
            return `${window.location.protocol}//${window.location.host}?signup=${this.partnerInfo.code}`
        },
        city: {
            get() {
                return this.editInfo.address.city
            },
            set(val) {
                this.editInfo.address.region = null;
                this.editInfo.address.city = val;
                if (val)
                    places.forEach(place => {
                        if (place.places.find(town => town === val))
                            this.editInfo.address.region = place.province
                    })
            }
        },
        towns() {
            return places.reduce((list, place) => {
                return list.concat(place.places)
            }, []).sort(nameSort)
        },
        provinces() {
            return places.map(place => place.province).sort(nameSort)
        },
        banks() {
            return banks.map(bank => bank.name).sort(nameSort)
        }
    }
}
</script>

<style scoped>

</style>